import WebService from "../WebService";

const Tags = {
  gets(params) {
    return WebService.get("/tags?" + params);
  },
  get(tag_id, params) {
    return WebService.get(
      "/tags/" + tag_id +'?'+ params
      //  +'&'+ target+'_id='+target_id
    );
  },
  update(data) {
    return WebService.post("/tags/" + data.tag_id, data);
  },
  create(data) {
    return WebService.post("/tags", data);
  }
};

export default Tags;
